const data = [
  {
    title: "Speak Freely",
    subTitle:
      'Say "hello" to a different messaging experience. An unexpected focus on privacy, combined with all of the features you expect.',
  },
];

export default data;
